/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { connectionsCreateOAuthRedirectUrl } from "../../funcs/connectionsCreateOAuthRedirectUrl.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.OAuthUrlCreate$inboundSchema,
};

export const tool$connectionsCreateOAuthRedirectUrl: ToolDefinition<
  typeof args
> = {
  name: "connections-create-O-auth-redirect-url",
  description: `Create Oauth Redirect Url

Creates a redirect url to redirect the user to when initializing an embedded connector.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await connectionsCreateOAuthRedirectUrl(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
